
import { defineComponent, onMounted, ref } from "vue";
import ApiService from "@/core/services/ApiService";
import CreateNoticeModal from "@/views/pages/Admin/other/Notice/CreateNoticeModal.vue";
import Status from "@/components/Status.vue";
import { translate } from "@/core/services/HelpersFun";
import { useStore } from "vuex";
import { Mutations } from "@/store/enums/StoreEnums";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
export default defineComponent({
  name: "kt-table-notice-management",
  props: {
    widgetClasses: String,
    id: {
      type: Number,
      default: undefined,
    },
  },
  components: {
    Status,
    CreateNoticeModal,
  },
  setup() {
    const page = ref(1);
    const pagination = ref();
    const store = useStore();
    const actionType = ref();
    const loading = ref(false);
    const list = ref();
    const editNoticeId = ref();
    const createNoticeModalRef = ref();

    onMounted(() => {
      getItems();
    });

    const getItems = () => {
      loading.value = true;
      editNoticeId.value = undefined;
      ApiService.get(`admin/notice?page=${page.value}`)
        .then(({ data }) => {
          list.value = data.data.notices.data;
          pagination.value = data.data.notices.pagination;
        })
        .catch(({ response }) => {
          // if (response && response.data)
          //   store.commit(Mutations.SET_ERROR, response.data);
        })
        .finally(() => {
          loading.value = false;
        });
    };

    const deleteNotice = (id) => {
      ApiService.post(`admin/notice/${id}/delete`, {})
        .then(() => {
          getItems();
        })
        .catch(({ response }) => {
          if (response && response.data)
            store.commit(Mutations.SET_ERROR, response.data);
        });
    };

    const handleCurrentChange = (val: number) => {
      page.value = val;
      getItems();
    };

    const setData = (botIdValue) => {
      editNoticeId.value = botIdValue;
    };

    const permission = ref();

    onMounted(() => {
      setTimeout(() => {
        let per: any = localStorage.getItem("permissions");
        permission.value = JSON.parse(per);
      }, 3000);

      setCurrentPageBreadcrumbs(translate("مدیریت اطلاعیه ها"), [
        translate("management"),
      ]);
    });

    return {
      list,
      loading,
      pagination,
      handleCurrentChange,
      getItems,
      deleteNotice,
      setData,
      editNoticeId,
      createNoticeModalRef,
      // getType,
      translate,
      actionType,
      permission,
    };
  },
});
